import { useMemo, useState } from 'react'
import { useVideoContext } from '../../../context/VideoContext'
import CustomTable from '../../Custom/Table'
import TableSearch, { filterRows } from '../../Custom/TableSearch'
import useVideoTable from './useVideoTable'


const VideoTable = () => {

    const { columns } = useVideoTable()
    const {videos} = useVideoContext()
    const [filtroBusqueda, setFiltroBusqueda] = useState('')

    const videosDate = useMemo(() => {
        const activos = [...videos].filter(video => video.activo).sort((a, b) => new Date(b.fechaRegistro).getTime() - new Date(a.fechaRegistro).getTime());
        return filterRows(activos, filtroBusqueda, ['titulo', 'descripcion_breve', 'contenido', 'categorias'])
    }, [videos, filtroBusqueda])

    return (
        <>
            <TableSearch
                value={filtroBusqueda}
                onChange={setFiltroBusqueda}
                label="Buscar video"
                placeholder="Título, descripción, contenido o categoría..."
            />
            <CustomTable rows={videosDate} columns={columns} />
        </>
    )

}

export default VideoTable
